import React$1 from 'react';

const Tick = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "19",
  height: "13",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M7.371 10l9.9-9.9 1.414 1.414-9.9 9.9-1.414 1.414L.3 5.758l1.414-1.415z"
}));

export default Tick;
